import { render, staticRenderFns } from "./GarantiasIndex.vue?vue&type=template&id=4e1529e0&scoped=true"
import script from "./GarantiasIndex.vue?vue&type=script&lang=js"
export * from "./GarantiasIndex.vue?vue&type=script&lang=js"
import style0 from "./GarantiasIndex.vue?vue&type=style&index=0&id=4e1529e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1529e0",
  null
  
)

export default component.exports